
export function execute(http, url, request, getHttpDefaultOptions?: any, configService?) {
    // console.log("Request:",request);
    return http.post( url, request, getHttpDefaultOptions);
}

export function executePut(http, url, request, getHttpDefaultOptions?: any, configService?) {
    return http.put( url, request, getHttpDefaultOptions);
}

export function scrollToTop() {
    window.scrollTo(0, 0);
}